import React from 'react';
import {
  ChipRadio,
  ChipRadioGroup,
  ChipVariantEnum,
} from '@unisporkal/alliance-ui';
import cx from 'classnames';
import styles from './ButtonGroupSelector.module.scss';

export type ButtonGroupOption<T> = {
  value: T;
  label: React.ReactNode;
  // Stable selector for e2e tests — position-based, so it doesn't shift if `label`'s underlying number changes.
  testId?: string;
};

export type ButtonGroupSelectorProps<T> = {
  options: ButtonGroupOption<T>[];
  value: T | null;
  onChange: (value: T) => void;
  ariaLabel?: string;
  className?: string;
};

const ButtonGroupSelector = <T,>({
  options,
  value,
  onChange,
  ariaLabel,
  className,
}: ButtonGroupSelectorProps<T>) => {
  const handleChange = (newValue: string) => {
    const option = options.find((o) => String(o.value) === newValue);
    if (option) {
      onChange(option.value);
    }
  };

  return (
    <ChipRadioGroup
      aria-label={ariaLabel ?? ''}
      value={value === null ? '' : String(value)}
      variant={ChipVariantEnum.BRAND}
      onChange={handleChange}
      className={cx(styles.group, className)}
    >
      {options.map((option) => (
        <ChipRadio
          key={String(option.value)}
          value={String(option.value)}
          className={styles.button}
          data-testid={option.testId}
        >
          {option.label}
        </ChipRadio>
      ))}
    </ChipRadioGroup>
  );
};

export default ButtonGroupSelector;
